import { BankAccountFieldType } from '../constants/bank-account'
import {
  AddBankAccountArgs,
  BankAccountDto,
  BankAccountField,
  BankAccountFieldModel,
  BankAccountModel,
  BankAccountRegistrationDto,
  BankAccountRegistrationModel,
} from '../types/bank-account'

export const addBankAccountArgsToParams = ({
  name,
  accountNumber,
  routingNumber,
  addressId,
  spendingType,
}: AddBankAccountArgs) => ({
  name,
  user_address_id: addressId,
  account_number: accountNumber,
  routing_number: routingNumber,
  spending_type: spendingType,
})

export const transformBankAccount = ({
  id,
  name,
  account_number,
  routing_number,
  is_default,
  user_id,
  user_address_id,
  spending_type,
  hide_name,
  payee_verification,
}: BankAccountDto): BankAccountModel => ({
  id,
  name,
  accountNumber: account_number,
  routingNumber: routing_number,
  isDefault: !!is_default,
  userId: user_id,
  userAddressId: user_address_id,
  spendingType: spending_type,
  hideName: hide_name || null,
  payeeVerification: payee_verification
    ? {
        status: payee_verification.status,
        provider: payee_verification.provider,
        name: payee_verification.name,
      }
    : null,
})

export const transformBankAccounts = (
  bankAccounts: Array<BankAccountDto>,
): Array<BankAccountModel> => bankAccounts.map(transformBankAccount)

export const transformBankAccountField = ({
  required,
  keyboard_input_type,
  format,
  min_length,
  max_length,
  adjust_pattern,
  display,
}: BankAccountField): BankAccountFieldModel => ({
  required,
  keyboardInputType: keyboard_input_type,
  format,
  minLength: min_length,
  maxLength: max_length,
  adjustPattern: adjust_pattern,
  display: display || null,
})

export const transformBankAccountFields = (
  fields: Partial<Record<BankAccountFieldType, BankAccountField | null>>,
): Partial<Record<BankAccountFieldType, BankAccountFieldModel | null>> =>
  Object.keys(fields).reduce((acc, fieldType) => {
    const dtoField = fields[fieldType]

    return {
      ...acc,
      [fieldType]: dtoField ? transformBankAccountField(dtoField) : null,
    }
  }, {})

export const transformBankAccountRegistration = ({
  account_type,
  fields,
}: BankAccountRegistrationDto): BankAccountRegistrationModel => ({
  accountType: account_type,
  fields: transformBankAccountFields(fields),
})
